// ============================================================================
// MY WORKLOAD WIDGET — Phase 8.D
// ============================================================================
// Counts the recovery officer's IN_PROGRESS cases grouped by workflow state.
// Server-computed; no client-side aggregation.

import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import { useMyWorkload } from 'hooks/api/useRecoveryDashboard';

interface Props { refreshKey?: number; }

const MyWorkloadWidget: React.FC<Props> = ({ refreshKey }) => {
  const { data, loading } = useMyWorkload(refreshKey);

  return (
    <div className="dashboard-widget">
      <div className="dashboard-widget-header">
        <h3 className="dashboard-widget-title">
          <IconSystem.folder size={18} />
          My Workload
        </h3>
        <span className="dashboard-kpi-chip">{data?.totalOpen ?? 0}</span>
      </div>
      <div className="dashboard-widget-subtitle">
        Open cases assigned to me, by current stage
      </div>
      <div className="dashboard-widget-body">
        {loading ? (
          <div className="dashboard-widget-loading">Loading...</div>
        ) : !data || data.byStage.length === 0 ? (
          <div className="dashboard-widget-empty">No active cases assigned to you.</div>
        ) : (
          <div>
            {data.byStage.map(b => (
              <div key={b.stateCode} className="dashboard-stage-row">
                <span>{b.stateDisplayName || b.stateCode}</span>
                <span className="stage-count">{b.count}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyWorkloadWidget;
